<template>
  <div class="official-coach-bond">
    <div class="off-event-box">
      <img :src="bgImg.seq1">
      <img :src="bgImg.seq2">
      <img :src="bgImg.seq3">
      <img :src="bgImg.seq4">
    </div>
    <div class="off-footer-box display-flex-end">
      <div v-if="false" class="off-btn-item blue"><div>联系顾问</div></div>
      <div class="off-btn-item yellow" @click="goTrial"><div>我想试用</div></div>
    </div>
  </div>
</template>

<script>
import { getAppPath, varConfig, ImageFormat } from '@/utils'

export default {
  name: 'officialCoachBond',
  data() {
    return {
      bgImg: {}
    }
  },
  created() {
  },
  mounted() {
    this.shareData = {
      title: '邦少年・助力赛事方创收的比赛直播小程序',
      abstract: '聚焦青少年赛事 额外创收 定价灵活',
      link: this.getShareLink(),
      image: ImageFormat.squareImageView('Fq_9-N3V9Yx43w2hO_fQc-r_Tg7Y', 120)
    }
    this.wxShare(this.shareData)
    const bgImg = {}
    bgImg.seq1 = ImageFormat.squareImageView('FnTFs-XTOBd_RQJuFWXMWrbA0MPm', 0)
    bgImg.seq2 = ImageFormat.squareImageView('Fr5eepRw48UAfM0n8Dxrl8f101xL', 0)
    bgImg.seq3 = ImageFormat.squareImageView('FqWR-bsKgCARiqGS6EO-mXR7XMm6', 0)
    bgImg.seq4 = ImageFormat.squareImageView('FtISS2SLqeo0nVhWrwEqxU_w5UzC', 0)

    this.bgImg = bgImg
  },
  methods: {
    goTrial() {
      const path = getAppPath('webapplt')
      const url = `${varConfig.siteUrl}/${path}/index/index.html#/reservation?type=3&radio=体育培训公司&result=邦少年直播`
      window.location.href = url
    },
    getShareLink: function () {
      const arr = window.location.href.split('index.html')
      return arr[0] + 'index.html#/official-youth?v=1'
    }
  }
}
</script>

<style lang="scss">
  .official-coach-bond {
    .off-event-box{
      width: 100%;
      position: relative;
      padding-bottom: 51px;
      img{
        width: 100%;
        height: 100%;
        position: relative;
        top: 0;
        left: 0;
        display: block;
      }
    }
    .off-footer-box{
      position: fixed;
      bottom: 0;
      width: 100%;
      max-width: 480px;
      height: 50px;
      background: rgba(255, 255, 255, 0.8);
      padding: 4px 0;
      .off-btn-item{
        display: inline-block;
        padding: 4px 17px;
        border-radius: 24px;
        color: #FFFFFF;
        cursor: pointer;
      }
      .blue{
        background: linear-gradient(180deg, #6295E3 0%, #42659B 100%);
        margin-right: 15px;
      }
      .yellow{
        background: linear-gradient(180deg, #D7F099 0%, #8CD003 100%);
        margin-right: 38px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/official-youth/index.vue